/**
 * 常量定义
 */
export default {
  TEST: 'TEST Value',
  // 文档类型
  DOCUMENT_TYPES: [
    { value: 'ZBS', name: '说明书' },
    { value: 'SYS_INT', name: '说明文档' }
  ],
  // 模版配置，注意配置名称不要更改，获取配置时会自动组装名称来获取配置
  // 如ZBS_TEMPLATE_VARIABLES，其中ZBS取自DOCUMENT_TYPES，TEMPLATE取自作用域
  TEMPLATE_CONFIG: {
    // 管理系统
    MANAGE: {
      // 说明书全局文案变量
      ZBS_TEMPLATE_VARIABLES: [
        { variable: '${_systemZhName}', remark: '系统名称' },
        { variable: '${_modulesText}', remark: '模块列表' },
        { variable: '{{@首页}}', remark: '首页截图' },
        { variable: '{{@密码登录}}', remark: '密码登录截图' },
        { variable: '{{@用户管理}}', remark: '用户管理截图' },
        { variable: '{{@用户管理_新建}}', remark: '用户管理/新建用户截图' },
        { variable: '{{@用户管理_编辑}}', remark: '用户管理/编辑用户截图' },
        { variable: '{{@角色管理}}', remark: '角色管理截图' },
        { variable: '{{@角色管理_新建}}', remark: '角色管理/新建角色截图' },
        { variable: '{{@角色管理_编辑}}', remark: '角色管理/编辑角色截图' },
        { variable: '{{@角色管理_删除}}', remark: '角色管理/删除角色截图' },
        { variable: '{{@权限管理}}', remark: '权限管理截图' },
        { variable: '{{@权限管理_新建}}', remark: '权限管理/新建权限截图' },
        { variable: '{{@权限管理_编辑}}', remark: '权限管理/编辑权限截图' },
        { variable: '{{@权限管理_删除}}', remark: '权限管理/删除权限截图' },
        { variable: '{{@菜单管理}}', remark: '菜单管理截图' },
        { variable: '{{@菜单管理_新建}}', remark: '菜单管理/新建菜单截图' },
        { variable: '{{@菜单管理_编辑}}', remark: '菜单管理/编辑菜单截图' },
        { variable: '{{@菜单管理_删除}}', remark: '菜单管理/删除菜单截图' },
        { variable: '{{@字典管理}}', remark: '字典管理截图' },
        { variable: '{{@字典管理_新建}}', remark: '字典管理/新建字典截图' },
        { variable: '{{@操作日志}}', remark: '操作日志截图' },
        { variable: '{{@登录日志}}', remark: '登录日志截图' }
      ],
      // 说明书模块文案变量
      ZBS_MODULE_VARIABLES: [
        { variable: '${_zhName}', remark: '模块名称' },
        { variable: '${_fieldsText}', remark: '所有字段列表' },
        { variable: '${_searchFieldsText}', remark: '支持搜索的字段列表' },
        { variable: '${_operaFieldsText}', remark: '支持新建和编辑的字段列表' },
        { variable: '${_requiredFieldsText}', remark: '新建和编辑时必填的字段列表' },
        { variable: '{{@${_zhName}}}', remark: '本模块截图' },
        { variable: '{{@${_zhName}_新建}}', remark: '本模块新建数据时的截图' },
        { variable: '{{@${_zhName}_编辑}}', remark: '本模块编辑数据时的截图' },
        { variable: '{{@${_zhName}_删除}}', remark: '本模块删除数据时的截图' }
      ],
      // 说明文档文案变量
      SYS_INT_TEMPLATE_VARIABLES: [
        { variable: '${_systemZhName}', remark: '系统名称' },
        { variable: '${_modulesText}', remark: '模块列表' }
      ]
    },
    // 大屏系统
    BIG_SCREEN: {
      ZBS_TEMPLATE_VARIABLES: [
        { variable: '${_systemZhName}', remark: '系统名称' },
        { variable: '${_modulesText}', remark: '模块列表' }
      ],
      ZBS_MODULE_VARIABLES: [
        { variable: '${_zhName}', remark: '模块名称' },
        { variable: '${_fieldsText}', remark: '所有字段列表' }
      ],
      SYS_INT_TEMPLATE_VARIABLES: [
        { variable: '${_systemZhName}', remark: '系统名称' },
        { variable: '${_modulesText}', remark: '模块列表' }
      ]
    },
    // 移动端管理系统
    MOBILE_MANAGE: {
      ZBS_TEMPLATE_VARIABLES: [
        { variable: '${_systemZhName}', remark: '系统名称' },
        { variable: '${_modulesText}', remark: '模块列表' },
        { variable: '{{@首页}}', remark: '首页截图' },
        { variable: '{{@我的}}', remark: '我的页面截图' },
        { variable: '{{@待办事项}}', remark: '待办事项页面截图' },
        { variable: '{{@我的消息}}', remark: '我的消息页面截图' },
        { variable: '{{@修改密码}}', remark: '修改密码页面截图' },
        { variable: '{{@修改昵称}}', remark: '修改昵称页面截图' },
        { variable: '{{@修改头像}}', remark: '修改头像页面截图' },
        { variable: '{{@短信登录}}', remark: '短信登录截图' },
        { variable: '{{@用户管理}}', remark: '用户管理截图' },
        { variable: '{{@用户管理_新建}}', remark: '用户管理/新建用户截图' },
        { variable: '{{@用户管理_编辑}}', remark: '用户管理/编辑用户截图' },
        { variable: '{{@用户管理_删除}}', remark: '用户管理/删除用户截图' },
        { variable: '{{@角色管理}}', remark: '角色管理截图' },
        { variable: '{{@角色管理_新建}}', remark: '角色管理/新建角色截图' },
        { variable: '{{@角色管理_编辑}}', remark: '角色管理/编辑角色截图' },
        { variable: '{{@角色管理_删除}}', remark: '角色管理/删除角色截图' },
        { variable: '{{@角色管理_分配权限}}', remark: '角色管理/分配权限页面截图' },
        { variable: '{{@权限管理}}', remark: '权限管理截图' },
        { variable: '{{@权限管理_新建}}', remark: '权限管理/新建权限截图' },
        { variable: '{{@权限管理_编辑}}', remark: '权限管理/编辑权限截图' },
        { variable: '{{@权限管理_删除}}', remark: '权限管理/删除权限截图' },
        { variable: '{{@部门管理}}', remark: '部门管理截图' },
        { variable: '{{@部门管理_新建}}', remark: '部门管理/新建截图' },
        { variable: '{{@部门管理_编辑}}', remark: '部门管理/编辑截图' },
        { variable: '{{@部门管理_删除}}', remark: '部门管理/删除截图' },
        { variable: '{{@岗位管理}}', remark: '岗位管理截图' },
        { variable: '{{@岗位管理_新建}}', remark: '岗位管理/新建岗位截图' },
        { variable: '{{@岗位管理_编辑}}', remark: '岗位管理/编辑截图' },
        { variable: '{{@岗位管理_删除}}', remark: '岗位管理/删除截图' },
        { variable: '{{@操作日志}}', remark: '操作日志截图' },
        { variable: '{{@登录日志}}', remark: '登录日志截图' },
        { variable: '{{@服务监测}}', remark: '服务监测截图' },
      ],
      ZBS_MODULE_VARIABLES: [
        { variable: '${_zhName}', remark: '模块名称' },
        { variable: '${_fieldsText}', remark: '所有字段列表' },
        { variable: '${_searchFieldsText}', remark: '支持搜索的字段列表' },
        { variable: '${_operaFieldsText}', remark: '支持新建和编辑的字段列表' },
        { variable: '${_requiredFieldsText}', remark: '新建和编辑时必填的字段列表' },
        { variable: '{{@${_zhName}}}', remark: '本模块截图' },
        { variable: '{{@${_zhName}_新建}}', remark: '本模块新建数据时的截图' },
        { variable: '{{@${_zhName}_编辑}}', remark: '本模块编辑数据时的截图' },
        { variable: '{{@${_zhName}_删除}}', remark: '本模块删除数据时的截图' }
      ],
      SYS_INT_TEMPLATE_VARIABLES: [
        { variable: '${_systemZhName}', remark: '系统名称' },
        { variable: '${_modulesText}', remark: '模块列表' }
      ]
    }
  }
}
